import { render, staticRenderFns } from "./LedgerCategoriesTable.vue?vue&type=template&id=6b95a9a0&"
import script from "./LedgerCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./LedgerCategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./LedgerCategoriesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports